import { Icon, useOpen } from "@dgs/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PaymentTransactionItem } from "../../../shared/types";
import { CancellationConfigItemsDrawer } from "./CancellationConfigItemsDrawer";

const CancellationConditionsButton = styled.button`
	display: grid;
	grid-template-columns: 20px max-content;
	gap: ${({ theme }) => theme.spacing(2)};
	background: none;
	font: inherit;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
`;

interface Props {
	item: PaymentTransactionItem;
}

export function CancellationConditions({ item }: Props) {
	const { t } = useTranslation();
	const { open, handleOpen, handleClose } = useOpen();

	if (!item.hasCancellationConfig) {
		return null;
	}

	return (
		<>
			<CancellationConditionsButton type="button" onClick={handleOpen}>
				<Icon $icon="eye" /> {t("Click here for cancellation conditions.")}
			</CancellationConditionsButton>
			<CancellationConfigItemsDrawer open={open} onClose={handleClose} shopItemId={item.shopItemId} />
		</>
	);
}
